"use client";

import { useEffect, useState, useRef } from "react";

import { useGetPrizeStraplineTextsQuery, useGetBotbPassMembersDataQuery } from "@/app/redux/features/api/membersHome";
import MemberCard from "./MemberCard";
import UnusedTicketsBar from "./UnusedTicketsBar";

export default function HeroSection() {
  const { data: strapline } = useGetPrizeStraplineTextsQuery();
  const { data: membersData } = useGetBotbPassMembersDataQuery();
  const hasUnusedTickets = membersData?.UnusedTickets ?? true;
  const prizesTotal = strapline?.PrizeStraplineText2 || "";

  const sectionRef = useRef<HTMLElement>(null);
  const [isFloating, setIsFloating] = useState(false);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsFloating(!entry.isIntersecting);
      },
      { threshold: 0 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative w-full overflow-hidden px-[18px] lg:px-6 py-8 lg:py-[58px]">
      <div
        className="absolute inset-0 pointer-events-none bg-[linear-gradient(180deg,#383a91_14%,#a62070_61%,rgba(195,111,161,0.4)_83%,transparent_100%)] lg:bg-[linear-gradient(180deg,#383a91_22%,#a62070_47%,#f5f5f5_100%)]"
        aria-hidden="true"
      />

      <div
        className={`fixed z-[100] !top-auto bottom-4 left-[18px] right-[18px] lg:bottom-auto lg:!top-1/2 lg:-translate-y-1/2 lg:left-auto lg:right-10 transition-[transform,visibility] duration-300 ${
          isFloating
            ? "translate-y-0 lg:translate-x-0 visible"
            : "translate-y-[calc(100%+16px)] lg:translate-x-[calc(100%+40px)] invisible pointer-events-none"
        }`}>
        <UnusedTicketsBar hasUnusedTickets={hasUnusedTickets} />
      </div>

      <div className="relative max-w-[1170px] mx-auto flex flex-col-reverse lg:flex-row items-center gap-6 lg:gap-16">
        <MemberCard />

        <div className="flex flex-col gap-12 items-center lg:items-start w-full lg:max-w-[534px]">
          <div className="flex flex-col gap-4 items-center lg:items-start">
            <h1 className="!m-0 p-0 normal-case text-white text-[22px] lg:text-[32px] xl:text-[40px] font-semibold font-jost leading-7 lg:leading-tight text-center lg:text-left">
              🎉 {`Congrats, you're in for `}
              <>
                <br />
                <span className="text-primary">£2.3M+ in prizes</span>
              </>
              {` this month!`}
            </h1>
            <p className="hidden lg:block m-0 p-0 tracking-[0] text-white text-[22px] font-normal font-jost leading-7 text-left">
              Good to have you here. Exclusive access, bigger prizes — that's your BOTB Pass, every month
            </p>
          </div>

          <div className={`hidden lg:block ${isFloating ? "lg:invisible" : ""}`}>
            <UnusedTicketsBar hasUnusedTickets={hasUnusedTickets} />
          </div>
        </div>
      </div>
    </section>
  );
}
